// Taxibel public site: theme toggle and "Requisitos" link that opens its FAQ.

const root = document.documentElement;

document.querySelectorAll("[data-theme-toggle]").forEach((button) => {
  button.addEventListener("click", () => {
    const next = root.getAttribute("data-theme") === "light" ? "dark" : "light";
    root.setAttribute("data-theme", next);
    try { localStorage.setItem("taxibel.theme", next); } catch (e) { /* private mode */ }
  });
});

document.querySelectorAll("[data-open-faq]").forEach((link) => {
  link.addEventListener("click", () => {
    const item = document.getElementById(link.dataset.openFaq);
    if (item) item.open = true;
  });
});
